import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';

const AccessDenied: React.FC = () => {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '80vh',
          gap: 2,
          textAlign: 'center',
          px: 3,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 80,
            height: 80,
            borderRadius: '50%',
            bgcolor: 'error.light',
            mb: 1,
          }}
        >
          <LockOutlinedIcon sx={{ fontSize: 40, color: 'error.contrastText' }} />
        </Box>

        <Typography variant="h4" fontWeight={700}>
          Access Denied
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 420 }}>
          You don't have permission to view this page. Please contact your
          administrator if you believe this is a mistake.
        </Typography>

        <Button variant="contained" onClick={() => navigate(-1)} sx={{ mt: 1 }}>
          Go Back
        </Button>
      </Box>
    </DashboardLayout>
  );
};

export default AccessDenied;
